module.exports = __webpack_public_path__ + "static/img/zzc_6.465317f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Zuzuche_Pro/zzc_6.png
// module id = NzGw
// module chunks = 19